import React, { useMemo } from 'react'
import { useLabelMap } from 'src/context/LabelsContext'
import { FittedChipList } from '../Chips/FittedChipList'

// Labels by name, as many as fit the cell, all of them listed on hover when some don't.
export const LabelSummary = ({
  labelIds,
  subjectId,
}: {
  labelIds: string[]
  subjectId: string
}): JSX.Element => {
  const labelMap = useLabelMap()
  const names = useMemo(
    () => labelIds.map((id) => labelMap[id] || id),
    [labelIds, labelMap],
  )

  return (
    <FittedChipList
      items={names}
      tooltipId={`label-summary-tooltip-${subjectId}`}
      tooltipBody={names.join(', ')}
    />
  )
}
